import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Col,
  Spinner
} from "reactstrap";
import { addRestaurantImages } from "store/actions/settingAction";
import Dropzone from "react-dropzone";

const AddRestaurantImageModal = ({
  addModal,
  addToggle,
  data,
  galleryImages,
  setGalleryImages
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { addLoading } = useSelector((state) => state.setting);

  const MAX_FILE_SIZE = 1024 * 1024;

  const handleDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 1) {
      toast.warn("Only one image can be selected at a time.");
      return;
    }

    const file = acceptedFiles[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      toast.warn("Invalid file type. Only image files are allowed.");
    } else if (file.size > MAX_FILE_SIZE) {
      toast.warn("File size too large. Maximum allowed is 1MB.");
    } else {
      const tempObj = {
        image: file,
        imageUrl: URL.createObjectURL(file)
      };
      setGalleryImages([tempObj]);
    }
  };

  const handleRemoveGalleryImage = (ind) => {
    let temp = [...galleryImages];
    temp.splice(ind, 1);
    setGalleryImages(temp);
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (galleryImages?.length > 0) {
      dispatch(
        addRestaurantImages(user?.restaurantID, galleryImages, () => {
          addToggle();
          setGalleryImages([]);
        })
      );
    } else {
      toast.warn("Please select images");
    }
  };

  return (
    <div>
      <Modal isOpen={addModal} toggle={addToggle}>
        <ModalHeader toggle={addToggle}>Add Restaurant Images</ModalHeader>
        <ModalBody className="pt-0">
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Restaurant Images</Label>
              <Dropzone onDrop={handleDrop} multiple={false}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <section
                    className="dropzone"
                    style={{
                      border: "2px dashed #6c757d",
                      backgroundColor: isDragActive ? "#f8f9fa" : "#fff",
                      height: "140px",
                      borderRadius: "10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      transition: "background-color 0.3s ease",
                      marginBottom: "1.5rem"
                    }}
                  >
                    <div className="text-center p-2" {...getRootProps()}>
                      <input {...getInputProps()} />
                      <i className="fas fa-upload fa-2x mb-2 text-primary opacity-5"></i>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.9rem",
                          color: "#6c757d"
                        }}
                      >
                        {isDragActive
                          ? "Drop the images here..."
                          : "Drag & drop or click to select images"}
                      </p>
                    </div>
                  </section>
                )}
              </Dropzone>
            </FormGroup>

            {galleryImages.length > 0 && (
              <Row className="mb-4 justify-content-center">
                {galleryImages.map((obj, ind) => (
                  <Col
                    md={4}
                    sm={6}
                    xs={12}
                    key={ind}
                    className="mb-3 d-flex justify-content-center"
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block"
                      }}
                    >
                      <img
                        src={obj.imageUrl}
                        alt="Preview"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "10px",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                          border: "1px solid #dee2e6"
                        }}
                      />
                      <div
                        onClick={() => handleRemoveGalleryImage(ind)}
                        style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          backgroundColor: "#dc3545",
                          color: "#fff",
                          borderRadius: "50%",
                          width: "22px",
                          height: "22px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: "0.8rem",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
                        }}
                        title="Remove"
                      >
                        <i className="fa fa-times"></i>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            )}

            <div className="d-flex justify-content-end">
              <Button
                color="primary"
                a
                type="submit"
                disabled={addLoading || galleryImages.length === 0}
              >
                {addLoading ? <Spinner size="sm" /> : "Add"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default AddRestaurantImageModal;
